// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Theme System - CSS Variables for Mobile-First Design */

:root {
  /* Spacing Scale (Mobile First) */
  --spacing-xs: 0.25rem;   /* 4px */
  --spacing-sm: 0.5rem;    /* 8px */
  --spacing-md: 1rem;      /* 16px */
  --spacing-lg: 1.5rem;    /* 24px */
  --spacing-xl: 2rem;      /* 32px */
  --spacing-2xl: 3rem;     /* 48px */
  
  /* Breakpoints */
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  
  /* Layout */
  --navbar-height: 56px;
  --drawer-width-desktop: 250px;
  --content-padding-mobile: var(--spacing-md);
  --content-padding-desktop: var(--spacing-lg);
  
  /* Touch Targets */
  --touch-target-min: 44px;
  
  /* Typography (Mobile First) */
  --font-size-xs: 0.75rem;   /* 12px */
  --font-size-sm: 0.875rem;  /* 14px */
  --font-size-base: 1rem;    /* 16px */
  --font-size-lg: 1.125rem;  /* 18px */
  --font-size-xl: 1.25rem;   /* 20px */
  --font-size-2xl: 1.5rem;   /* 24px */
  --font-size-3xl: 1.875rem; /* 30px */
  
  /* Line Heights */
  --line-height-tight: 1.25;
  --line-height-normal: 1.5;
  --line-height-relaxed: 1.75;
  
  /* Border Radius */
  --border-radius-sm: 0.25rem;
  --border-radius-md: 0.375rem;
  --border-radius-lg: 0.5rem;
  
  /* Shadows */
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  
  /* Colors (Bootstrap compatible) */
  --color-primary: #0d6efd;
  --color-secondary: #6c757d;
  --color-success: #198754;
  --color-danger: #dc3545;
  --color-warning: #ffc107;
  --color-info: #0dcaf0;
  --color-light: #f8f9fa;
  --color-dark: #212529;
  
  /* Background Colors */
  --bg-light: #f8f9fa;
  --bg-white: #ffffff;
  --bg-gray: #e9ecef;
  
  /* Text Colors */
  --text-primary: #212529;
  --text-secondary: #6c757d;
  --text-muted: #6c757d;
  
  /* Border Colors */
  --border-color: #dee2e6;
  --border-color-light: #e9ecef;
}

`, "",{"version":3,"sources":["webpack://./src/styles/theme.css"],"names":[],"mappings":"AAAA,yDAAyD;;AAEzD;EACE,iCAAiC;EACjC,qBAAqB,IAAI,QAAQ;EACjC,oBAAoB,KAAK,QAAQ;EACjC,kBAAkB,OAAO,SAAS;EAClC,oBAAoB,KAAK,SAAS;EAClC,kBAAkB,OAAO,SAAS;EAClC,mBAAmB,MAAM,SAAS;;EAElC,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;;EAEvB,WAAW;EACX,qBAAqB;EACrB,6BAA6B;EAC7B,2CAA2C;EAC3C,4CAA4C;;EAE5C,kBAAkB;EAClB,wBAAwB;;EAExB,8BAA8B;EAC9B,uBAAuB,IAAI,SAAS;EACpC,wBAAwB,GAAG,SAAS;EACpC,sBAAsB,KAAK,SAAS;EACpC,wBAAwB,GAAG,SAAS;EACpC,uBAAuB,IAAI,SAAS;EACpC,uBAAuB,IAAI,SAAS;EACpC,yBAAyB,EAAE,SAAS;;EAEpC,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;;EAE3B,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,0BAA0B;;EAE1B,YAAY;EACZ,4CAA4C;EAC5C,8CAA8C;EAC9C,gDAAgD;;EAEhD,kCAAkC;EAClC,wBAAwB;EACxB,0BAA0B;EAC1B,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;;EAErB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;;EAElB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;;EAErB,kBAAkB;EAClB,uBAAuB;EACvB,6BAA6B;AAC/B","sourcesContent":["/* Theme System - CSS Variables for Mobile-First Design */\n\n:root {\n  /* Spacing Scale (Mobile First) */\n  --spacing-xs: 0.25rem;   /* 4px */\n  --spacing-sm: 0.5rem;    /* 8px */\n  --spacing-md: 1rem;      /* 16px */\n  --spacing-lg: 1.5rem;    /* 24px */\n  --spacing-xl: 2rem;      /* 32px */\n  --spacing-2xl: 3rem;     /* 48px */\n  \n  /* Breakpoints */\n  --breakpoint-sm: 576px;\n  --breakpoint-md: 768px;\n  --breakpoint-lg: 992px;\n  --breakpoint-xl: 1200px;\n  \n  /* Layout */\n  --navbar-height: 56px;\n  --drawer-width-desktop: 250px;\n  --content-padding-mobile: var(--spacing-md);\n  --content-padding-desktop: var(--spacing-lg);\n  \n  /* Touch Targets */\n  --touch-target-min: 44px;\n  \n  /* Typography (Mobile First) */\n  --font-size-xs: 0.75rem;   /* 12px */\n  --font-size-sm: 0.875rem;  /* 14px */\n  --font-size-base: 1rem;    /* 16px */\n  --font-size-lg: 1.125rem;  /* 18px */\n  --font-size-xl: 1.25rem;   /* 20px */\n  --font-size-2xl: 1.5rem;   /* 24px */\n  --font-size-3xl: 1.875rem; /* 30px */\n  \n  /* Line Heights */\n  --line-height-tight: 1.25;\n  --line-height-normal: 1.5;\n  --line-height-relaxed: 1.75;\n  \n  /* Border Radius */\n  --border-radius-sm: 0.25rem;\n  --border-radius-md: 0.375rem;\n  --border-radius-lg: 0.5rem;\n  \n  /* Shadows */\n  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n  \n  /* Colors (Bootstrap compatible) */\n  --color-primary: #0d6efd;\n  --color-secondary: #6c757d;\n  --color-success: #198754;\n  --color-danger: #dc3545;\n  --color-warning: #ffc107;\n  --color-info: #0dcaf0;\n  --color-light: #f8f9fa;\n  --color-dark: #212529;\n  \n  /* Background Colors */\n  --bg-light: #f8f9fa;\n  --bg-white: #ffffff;\n  --bg-gray: #e9ecef;\n  \n  /* Text Colors */\n  --text-primary: #212529;\n  --text-secondary: #6c757d;\n  --text-muted: #6c757d;\n  \n  /* Border Colors */\n  --border-color: #dee2e6;\n  --border-color-light: #e9ecef;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
